import React from "react";
import PolicyLayout from "./PolicyLayout";
import { ALCOHOL_NOTICE } from "../config/siteConfig";

function ProductSafety() {
  return (
    <PolicyLayout
      title="Product safety and care policy"
      intro="Use each product only for the purpose, material limits and care instructions stated on its page and delivered label."
    >
      <section>
        <h2>Fragile décor and tableware</h2>
        <p>Inspect glass, mirrors, porcelain and stoneware before first use. Keep them away from unstable edges and rapid temperature change. Do not use cracked food-contact ware, a chipped mirror or a candle holder that has become unstable. Broken pieces must be isolated from children and pets and handled with cut-resistant protection.</p>
      </section>

      <section>
        <h2>Lamps, candles and heat</h2>
        <p>Operate lamps upright in a dry indoor location with ventilation and the compatible voltage and plug information shown on the supplied electrical label. Unplug before cleaning. Do not modify wiring, cover a lit lamp, or operate a damaged cord, plug, housing or diffuser. Keep paper shades, textiles and wood away from open flame. Candles require a stable heat-resistant surface and continuous adult attention while lit.</p>
      </section>

      <section>
        <h2>Food, allergens, caffeine and packaging integrity</h2>
        <p>Read the physical pack every time before eating or drinking. Chocolate products can contain or share handling with milk, nuts, peanuts, gluten, soy or egg. Tea and kola beverages contain caffeine. Follow the delivered date and storage directions, refrigerate after opening where instructed, and discard any product with an unexpected odour, appearance, broken seal, leak, swollen pack or damaged bottle.</p>
      </section>

      <section>
        <h2>Alcohol controls</h2>
        <div className="policy-callout">{ALCOHOL_NOTICE}</div>
        <p>The buyer must make the checkout age declaration and arrange lawful receipt by an eligible adult. Keep spirits sealed, upright and away from heat and children. Do not drink before driving, operating equipment or carrying out an activity requiring unimpaired judgment.</p>
      </section>

      <section>
        <h2>Accessories, textiles and small components</h2>
        <p>Secure enamel-pin points with their clasp and keep pins, patch needles and small fasteners away from young children. Use a pressing cloth and adult handling when heat-applying patches; never apply heat to leather, coated, stretch or heat-sensitive material. Open hand fans slowly to avoid the pivot pinch point. Wash colour-sensitive cotton separately as directed and keep loose fabric away from flame or moving machinery.</p>
      </section>

      <section>
        <h2>Warnings and incident reports</h2>
        <p>A safety warning required for goods supplied in Hong Kong must be conspicuous and provided in both English and Chinese on the goods, packaging, label or enclosed document as applicable. Retain those instructions. For injury, overheating, contamination, breakage during ordinary use or another safety incident, stop use, obtain urgent assistance where necessary, preserve the item safely and report the order number, event and photographs.</p>
      </section>
    </PolicyLayout>
  );
}

export default ProductSafety;
